import { render, staticRenderFns } from "./progresso-setor.vue?vue&type=template&id=2a57127b&"
import script from "./progresso-setor.vue?vue&type=script&lang=js&"
export * from "./progresso-setor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports